/**
 * Growth Channel utilities
 * Shared helpers for identifying and labeling growth-channel-sourced leads.
 */

/** Sources that map to the Meta Growth Engine */
const META_SOURCES = new Set(["facebook ads", "meta", "facebook", "instagram", "meta ads"]);

/** Check if a lead source is from a managed growth channel */
export function isGrowthChannelSource(source: string | undefined): boolean {
  if (!source) return false;
  return META_SOURCES.has(source.toLowerCase());
}

/** Get the growth channel label for display */
export function getGrowthChannelLabel(source: string | undefined): string | null {
  if (!source) return null;
  if (META_SOURCES.has(source.toLowerCase())) return "Meta — Koridor Growth Engine";
  return null;
}

/** Get a short badge label */
export function getGrowthChannelBadge(source: string | undefined): string | null {
  if (!source) return null;
  if (META_SOURCES.has(source.toLowerCase())) return "Channel";
  return null;
}
